var map = {
	"./goldcoin/index-btn-icon-2.png": 14745,
	"./memetown/index-btn-icon-2.png": 78903,
	"./reflection/index-btn-icon-2.png": 32233,
	"./tapcoin/index-btn-icon-2.png": 7031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40255;